import React, { useState } from "react";

import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import AreyouHostessModel from "../Assets/Group4.png";
import icon from "../Assets/pngwing.com (73) 1.png";
import icon2 from "../Assets/new (1).png";
import icon3 from "../Assets/new (2).png";
import icon4 from "../Assets/new (3).png";


import img6 from "../Assets/rb_2148518507.png";
import SEOData from "../Components/SEOData";

const faqData = [
  {
    question: "I would like to meet a hostess/Model, what can i ask?",
    answer:
      "The hostesses/models on our site are not escorts, and requests/offers of sexual services are not tolerated. The services offered include companionship for dinners, aperitifs, events, trips, holidays, photo shoots, hostess services, ",
  },
  {
    question: "Hostess/Models Rates?",
    answer:
      "You can track your order using the tracking number provided in the confirmation email.",
  },
  {
    question: "Privacy and confidentiality?",
    answer:
      "Yes, we ship internationally. Shipping rates and delivery times may vary.",
  },
  {
    question: "Credits, costs and refunds?",
    answer:
      "Yes, we ship internationally. Shipping rates and delivery times may vary.",
  },
  {
    question: "Dating and Security?",
    answer:
      "Yes, we ship internationally. Shipping rates and delivery times may vary.",
  },
  {
    question: "Are consultations available outside regular business hours?",
    answer:
      "Yes, we ship internationally. Shipping rates and delivery times may vary.",
  },
];
function HowItWoks() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <Navbar />
      <SEOData PageName={'howitwoks'} />
      <div className="banner2">
        <h4>Simple and safe</h4>
        <h2>How Its Work</h2>
        <p>Home - How Its Work</p>
      </div>
      <div className="firstplatform">
        <h3>
          Hostess is the first platform that puts hostesses/models in your
          area in direct communication with you who offer their time for a fee.
        </h3>
      </div>
      <div className="modal-res">
        <div className="modal-overlay">
          <h2>Are you a Hostess/Model?</h2>
          <div className="modal-overlay-pints-cards">
            <div className="modal-overlay-pints-card">
              <div className="modal-overlay-pints-point">
                <h3>1</h3>
              </div>
              <div className="modal-overlay-pints-text">
                <h4>Register for Free</h4>
              </div>
            </div>
            <div className="modal-overlay-pints-card">
              <div className="modal-overlay-pints-point">
                <h3>2</h3>
              </div>
              <div className="modal-overlay-pints-text">
                <h4>Complete your Profile</h4>
              </div>
            </div>
            <div className="modal-overlay-pints-card">
              <div className="modal-overlay-pints-point">
                <h3>3</h3>
              </div>
              <div className="modal-overlay-pints-text">
                <h4>Proposals and Agree</h4>
              </div>
            </div>
            <div className="modal-overlay-pints-card">
              <div className="modal-overlay-pints-point">
                <h3>4</h3>
              </div>
              <div className="modal-overlay-pints-text">
                <h4>Enjoy and Repeat</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className='AreyouHostessModel'>
        <div className='AreyouHostessModel-left'>
        <h4>Are you a Hostess/Model?</h4>
        <br/>
        <br/>
        <br/>
        <div className='count'>
        <div className='count-div'>
        <h3>1</h3>

</div>
<h2>Register for Free</h2>

        </div>
        <br/>
        <div className='line'></div>
        <br/>


        <div className='count'>
        <div className='count-div'>
        <h3>2</h3>

</div>
<h2>Complete your Profile</h2>

        </div>
        <br/>
        <div className='line'></div>

        <br/>

        <div className='count'>
        <div className='count-div'>
        <h3>3</h3>

</div>
<h2>Evaluate the proposals and agree on a fee</h2>

        </div>
        <br/>
        <div className='line'></div>

        <br/>
        <div className='count'>
        <div className='count-div'>
        <h3>4</h3>

</div>
<h2>Enjoy and repeat ;)</h2>

        </div>


</div>
 <div className='AreyouHostessModel-right'>
 <img src={AreyouHostessModel}/>

</div>
        </div> */}
      <div className="AreyouHostessModel">
        <div className="AreyouHostessModel-right">
          <img src={AreyouHostessModel} />
        </div>
        <div className="AreyouHostessModel-left">
          <h4>Are you a Looking for a Hostess/Model?</h4>
          <br />
          <br />
          <br />
          <div className="count">
            <div>
              <div className="count-div">
                <h3>1</h3>
              </div>
            </div>

            <h2>Register for Free</h2>
          </div>
          <br />
          <div className="line"></div>
          <br />

          <div className="count">
            <div>
              <div className="count-div">
                <h3>2</h3>
              </div>
            </div>

            <h2>Browse profiles near you</h2>
          </div>
          <br />
          <div className="line"></div>

          <br />

          <div className="count">
            <div>
              <div className="count-div">
                <h3>3</h3>
              </div>
            </div>
            <h2>Unblock the chat and agree</h2>
          </div>
          <br />
          <div className="line"></div>

          <br />
          <div className="count">
            <div>
              <div className="count-div">
                <h3>4</h3>
              </div>
            </div>
            <h2>Enjoy and repeat ;)</h2>
          </div>
        </div>
      </div>
      <br />
      <br />

      <div className="Areyou">
        <h2>Are you a Hostess/Model?</h2>
        <div className="Areyou-cards">
          <div>
            <div className="Areyou-card">
              <img src={icon} />
              <br />
              <h3>
                Lunches and
                <br /> Dinners
              </h3>
            </div>
          </div>

          <div>
            <div className="Areyou-card">
              <img src={icon2} />
              <br />
              <h3>
              Aperitifs, Clubbinng, Events
              </h3>
            </div>
          </div>

          <div>
            <div className="Areyou-card">
              <img src={icon3} />
              <br />
              <h3>
              Trips and Weekends
              </h3>
            </div>
          </div>

          <div>
            <div className="Areyou-card">
              <img src={icon4} />
              <br />
              <h3>
              Fake Girlfriend
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div className="faq">
        <div className="faq-heading">
          <h3>Frequently Asked Question</h3>
          <br />
          <br />
          <div className="faq-div">
            <div className="faq-div-left">
              <img src={img6} />
            </div>
            <div className="faq-div-right">
              <div className="accordion">
                {faqData.map((faq, index) => (
                  <div className="accordion-item" key={index}>
                    <div
                      className="accordion-header"
                      onClick={() => toggleAccordion(index)}
                    >
                      <button className="accordion-toggle">
                        <h3>
                          {" "}
                          <span>{openIndex === index ? "-" : "+"}</span>{" "}
                          {faq.question}
                        </h3>
                      </button>
                    </div>
                    <div
                      className="accordion-content"
                      style={{ maxHeight: openIndex === index ? "100px" : "0" }}
                    >
                      <p>{faq.answer}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default HowItWoks;
